import React from "react";

export default (props) => {
  return (
    <div>
      {props.randomization_platform_step_3_participant_after_deferral_content ? (
        <div
          dangerouslySetInnerHTML={{
            __html: props.randomization_platform_step_3_participant_after_deferral_content,
          }}
        />
      ) : (
        <h4 align="center">
          Template not loaded
          <br/>
          <br/>
        </h4>
      )}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/ConsentTypeMevo/Texts/PatientAfterDeferralElectronicText.js